import DOMPurify from 'isomorphic-dompurify';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { RatingPageSeoFragmentFragmentDoc } from '@packages/gql/generated/shopping/RatingPageSeoFragmentFragmentDoc';
import { useConfig } from '@packages/utilities';
import Head from 'next/head';
import { usePathname } from 'next/navigation';
import { useIntl } from 'react-intl';
import { ratingPageHeadMessages } from './messages';

/* TODO: replace frontend-logic with graphql-call to seo-resolver for title and canonical */

/* GraphQL */ `
  fragment RatingPageSeoFragment on Product {
    name
    seo(locale: $locale) {
      title
      description
      keywords
    }
  }
`;

interface RatingPageHeadProps {
  data: FragmentType<typeof RatingPageSeoFragmentFragmentDoc>;
}

/**
 * RatingPageHead component description displayed in storybook
 * */
export const RatingPageHead = ({ data }: RatingPageHeadProps) => {
  const { formatMessage } = useIntl();
  const pathname = usePathname() || '';

  const { host, company } = useConfig();
  const { name, seo } = getFragmentData(RatingPageSeoFragmentFragmentDoc, data);

  return (
    <Head>
      <title>{`${formatMessage(ratingPageHeadMessages.title)} | ${
        seo?.title && seo.title.length > 0
          ? seo.title.replace('{ProductName}', name)
          : `${name} | ${company.seoTitleName}`
      }`}</title>
      <meta name="robots" content="noodp,noindex,follow" />
      <link href={`https://www.${host.domain}${pathname}`} rel="canonical" />
      {seo?.keywords && <meta name="keywords" content={seo.keywords} />}
      {seo?.description && (
        <meta
          name="description"
          content={DOMPurify.sanitize(seo.description.replace('{ProductName}', name))}
        />
      )}
    </Head>
  );
};
